import { render, staticRenderFns } from "./Prorate_permintaan.vue?vue&type=template&id=826d9472&scoped=true"
import script from "./Prorate_permintaan.vue?vue&type=script&lang=js"
export * from "./Prorate_permintaan.vue?vue&type=script&lang=js"
import style0 from "./Prorate_permintaan.vue?vue&type=style&index=0&id=826d9472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826d9472",
  null
  
)

export default component.exports